export interface SectionSubpageActionRoute {
    action: string | null;
    id: string | null;
}

export const buildSectionSubpageBasePath = (
    sectionRoot: string,
    subpage: string
): string => {
    return `/${sectionRoot}/${subpage}`;
};

export const buildSectionSubpageActionPath = (
    sectionRoot: string,
    subpage: string,
    action: string,
    id?: string | number | null
): string => {
    const basePath = buildSectionSubpageBasePath(sectionRoot, subpage);

    if (id === undefined || id === null || id === '') {
        return `${basePath}/${action}`;
    }

    return `${basePath}/${action}/${encodeURIComponent(String(id))}`;
};

export const parseSectionSubpageActionRoute = (
    pathname: string,
    sectionRoot: string,
    subpage: string,
    validActions: string[]
): SectionSubpageActionRoute => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] !== sectionRoot || segments[1] !== subpage) {
        return { action: null, id: null };
    }

    const action = segments[2];
    if (!action || !validActions.includes(action)) {
        return { action: null, id: null };
    }

    const rawId = segments[3];
    if (!rawId) {
        return { action, id: null };
    }

    return {
        action,
        id: decodeURIComponent(rawId),
    };
};